import { render, staticRenderFns } from "./DefaultNavBar.vue?vue&type=template&id=0aea366a&scoped=true&"
import script from "./DefaultNavBar.vue?vue&type=script&lang=js&"
export * from "./DefaultNavBar.vue?vue&type=script&lang=js&"
import style0 from "./DefaultNavBar.vue?vue&type=style&index=0&id=0aea366a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aea366a",
  null
  
)

export default component.exports